export default __webpack_public_path__ + "static/media/medard.1080a25b.jpg";